import { ValueNode } from './ValueNode';
export class DataNode extends ValueNode {
    value;
    constructor(id, value, key, metadata) {
        super(id, key, metadata);
        this.value = value;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGF0YU5vZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL3R5cGVzL3JlY29yZC9EYXRhTm9kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sYUFBYSxDQUFBO0FBSXZDLE1BQU0sT0FBTyxRQUFTLFNBQVEsU0FBUztJQUM1QixLQUFLLENBQVc7SUFFekIsWUFBWSxFQUFVLEVBQUUsS0FBZ0IsRUFBRSxHQUFZLEVBQUUsUUFBbUI7UUFDekUsS0FBSyxDQUFDLEVBQUUsRUFBRSxHQUFHLEVBQUUsUUFBUSxDQUFDLENBQUE7UUFDeEIsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUE7SUFDcEIsQ0FBQztDQUNGIn0=